import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { appVersionCopy } from "../copy";
import { useUpdateAvailable } from "../hooks";

/** Faixa no topo de qualquer tela quando ha versao nova no servidor.
 *  Fica no fluxo da pagina (sticky), e nao sobreposta, para nao cobrir o
 *  cabecalho dos layouts. Nao recarrega sozinha: o usuario pode estar no
 *  meio de um check-in ou digitando uma mensagem. */
export function UpdateBanner() {
  const available = useUpdateAvailable();
  if (!available) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-[100] flex flex-wrap items-center justify-center gap-x-4 gap-y-2 bg-primary-700 px-4 py-2 text-sm text-white shadow-md"
    >
      <p>
        <strong className="font-semibold">{appVersionCopy.message}</strong>{" "}
        <span className="opacity-90">{appVersionCopy.hint}</span>
      </p>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => window.location.reload()}
        className="shrink-0"
      >
        <RefreshCw aria-hidden />
        {appVersionCopy.action}
      </Button>
    </div>
  );
}
